import { render, staticRenderFns } from "./PayCenter.vue?vue&type=template&id=c64a8d48&scoped=true&"
import script from "./paycenter.js?vue&type=script&lang=js&"
export * from "./paycenter.js?vue&type=script&lang=js&"
import style0 from "./PayCenter.vue?vue&type=style&index=0&id=c64a8d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64a8d48",
  null
  
)

export default component.exports